import { simpleFetch as fetcher } from '@api/fetchers';
import { getCMSHost, getHost } from '@utils/api-helper/host';
import defaultCMSParamKey from '@api/hooks/platformBatchGroup/constant';

const defaultHost = getHost();
const CMSHost = getCMSHost();

export const fetchPlatformPartnerPageInfo = (key = defaultCMSParamKey) =>
  fetcher(`${CMSHost}api/platform-partner-page-infos/${key}`);

export const fetchPlatformPartnerPriceingPlans = (key = defaultCMSParamKey) =>
  fetcher(`${CMSHost}api/platform-partner-priceing-plans/${key}`);

export const fetchPlatformEducatorTestimonies = (key = defaultCMSParamKey) =>
  fetcher(`${CMSHost}api/platform-educator-testimonies/${key}`);

export const fetchPlatformUpcomingFilters = () =>
  fetcher(`${defaultHost}v1/batch/batch_group/list/filter_options`);

export const fetchPlatformBatchCourse = ({
  batchGroupUID,
  timezoneDifference,
  limit = 10,
  offset = 0,
  classType,
  accessToken
}) => {
  return fetcher(
    `${defaultHost}v1/batch/batch_group/${batchGroupUID}/lesson_groups/?limit=${limit}&timezone_difference=${timezoneDifference}&offset=${offset}&class_type=${classType}`,
    { authorization: accessToken }
  );
};

export const fetchBatchesGroupList = ({
  goalUID,
  groupType = 1,
  accessToken
}) => {
  return fetcher(
    `${defaultHost}v1/batch/batch_group/list/all/?goal_uid=${goalUID}&group_type=${groupType}`,
    { authorization: accessToken }
  );
};

export const fetchEnrolledBatches = (
  goalUID,
  accessToken,
  timezoneDifference
) => {
  return fetcher(
    `${defaultHost}v2/batch/enrolled_batch_group_data/?goal_uid=${goalUID}&timezone_difference=${timezoneDifference}`,
    { authorization: accessToken }
  );
};
